<template>
  <main>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <form-select :model="filterFormModel" attribute="status" :options="orderStatus"
                         class="mr-1 mb-1"></form-select>
            <client-select class="mr-1 mb-1" :model="filterFormModel" attribute="client"></client-select>
            <admin-user-select class="mr-1 mb-1" :model="filterFormModel" attribute="user"
                               :place-holder="$t('userInCharge')"></admin-user-select>
            <admin-user-select class="mr-1 mb-1" :model="filterFormModel" attribute="sales"
                               :place-holder="$t('sales')"></admin-user-select>
            <time-range-picker :model="filterFormModel" :label="$t('createTime')" class="mr-1 mb-1"></time-range-picker>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting"
             v-if="['owner', 'admin', 'tech', 'operationsManager', 'account', 'am', 'sales', 'kpiSales', 'manager'].includes($store.state.user.role)">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-3">{{ $t('orderInfo') }}</div>
            <div class="col-lg-3">{{ $t('payInfo') }}</div>
            <div class="col-lg-3">{{ $t('time') }}</div>
            <div class="col-lg-1 text-center">{{ $t('status') }}</div>
            <div class="col-lg-2 text-right"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-3">
              <p>
                <b>{{ $t('customer') }}: </b><span>{{ item.client.domain }}</span>
              </p>
              <p>
                <b>{{ $t('shippingName') }}: </b>
                <span v-if="item.shippingName">{{ item.shippingName }}</span>
                <span v-else class="text-secondary">{{ $t('notUpdated') }}</span>
              </p>
              <p>
                <b>{{ $t('shippingPhone') }}: </b>
                <span v-if="item.shippingPhone">{{ item.shippingPhone }}</span>
                <span v-else class="text-secondary">{{ $t('notUpdated') }}</span>
              </p>
              <p>
                <b>{{ $t('shippingAddress') }}: </b>
                <span v-if="item.shippingAddress">{{ item.shippingAddress }}</span>
                <span v-else class="text-secondary">{{ $t('notUpdated') }}</span>
              </p>
              <p>
                <b>{{ $t('productCount') }}: </b><span>{{ item.products.length }}</span>
              </p>
              <p v-if="item.buyUser">
                <b>{{ $t('buyUser') }}: </b>
                <span>{{ item.buyUser.email }} ({{ item.buyUser.ext }})</span>
              </p>
              <p>
                <b>{{ $t('source') }}: </b>
                <span v-if="item.source">{{ item.source }}</span>
                <span v-else class="text-secondary">{{ $t('notUpdated') }}</span>
              </p>
            </div>
            <div class="col-lg-3">
              <p>
                <b>{{ $t('payCode') }}: </b>
                <span v-if="item.code">TTC{{ item.code }}</span>
                <span v-else class="text-secondary">{{ $t('notUpdated') }}</span>
              </p>
              <p>
                <b>{{ $t('shipFee') }}: </b>
                <span v-if="item.shipFee">{{ item.shipFee | numFormat }}&nbsp;&#8363;</span>
                <span v-else>0&nbsp;&#8363;</span>
              </p>
              <p>
                <b>{{ $t('totalMoney') }}: </b>
                <span>{{ item.totalAmount | numFormat }}&nbsp;&#8363;</span>
              </p>
              <p>
                <b>{{ $t('paid') }}: </b>
                <span>{{ item.depositAmount + item.transferAmount | numFormat }}&nbsp;&#8363;</span>
              </p>
              <p>
                <b>{{ $t('missingAmount') }}: </b>
                <span class="text-danger">{{ item.totalAmount - item.depositAmount - item.transferAmount | numFormat }}&nbsp;&#8363;</span>
              </p>
            </div>
            <div class="col-lg-3">
              <p>
                <b>{{ $t('createTime') }}: </b><span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </p>
              <p>
                <b>{{ $t('updateTime') }}: </b>
                <span v-if="item.updateTime">{{ item.updateTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
                <span v-else class="text-secondary">{{ $t('notUpdated') }}</span>
              </p>
              <p>
                <b>{{ $t('deliveryTime') }}: </b>
                <span v-if="item.deliveryTime">{{ item.deliveryTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
                <span v-else class="text-secondary">{{ $t('notUpdated') }}</span>
              </p>
              <p v-if="item.confirmTime">
                <b>{{ $t('confirmTime') }}: </b>
                <span>{{ item.confirmTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </p>
              <p v-if="item.finishTime && !item.cancelTime">
                <b>{{ $t('finishTime') }}: </b>
                <span>{{ item.finishTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </p>
              <p v-if="item.cancelTime">
                <b>{{ $t('cancelTime') }}: </b>
                <span>{{ item.cancelTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              </p>
              <p>
                <b>{{ $t('userInCharge') }}: </b>
                <span v-if="item.user">{{ item.user.name }}</span>
                <span v-else class="text-secondary">{{ $t('notUpdated') }}</span>
              </p>
              <p>
                <b>{{ $t('sales') }}: </b>
                <span v-if="item.sales">{{ item.sales.name }}</span>
                <span v-else class="text-secondary">{{ $t('notUpdated') }}</span>
              </p>
            </div>
            <div class="col-lg-1 text-center">
              <div>
                <label v-if="!['return', 'returned', 'cancel', 'new', 'confirmed'].includes(item.status)"
                       class="badge badge-primary">{{ getStatus(item.status) }}</label>
                <label v-else-if="item.status === 'new'" class="badge badge-warning">{{
                    getStatus(item.status)
                  }}</label>
                <label v-else-if="item.status === 'confirmed'" class="badge badge-success">{{
                    getStatus(item.status)
                  }}</label>
                <label v-else class="badge badge-danger">{{ getStatus(item.status) }}</label>
              </div>
            </div>
            <div class="col-lg-2 text-right">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col">
                    <button @click="orderCare(item._id)" type="button"
                            v-if="!item.user && $store.state.user.role === 'am'"
                            class="btn btn-sm btn-secondary mr-1">
                      <font-awesome-icon icon="plus"/>&nbsp;{{ $t('orderCare') }}
                    </button>
                    <button
                        v-if="['owner', 'admin', 'tech', 'operationsManager', 'account', 'am', 'manager', 'accountant'].includes($store.state.user.role) || (['sales', 'kpiSales'].includes($store.state.user.role) && item.sales && item.sales._id === $store.state.user._id)"
                        @click="update(item._id)" type="button" class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                    </button>
                    <button @click="del(item._id)" type="button"
                            v-if="['owner', 'admin', 'tech', 'operationsManager', 'manager'].includes($store.state.user.role)"
                            class="btn btn-sm btn-danger mr-1">
                      <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>

      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal modal-class="modal-fullscreen custom-modal" v-model="showForm" size="xl" :title="formTitle" @ok="save"
             no-close-on-backdrop no-enforce-focus>
      <div class="row">
        <div class="col-md-8">
          <div class="row">
            <div class="col">
              <fieldset class="scheduler-border tile">
                <legend class="scheduler-border">{{ $t('product') }}</legend>
                <product-search-box :disabled="productDisabled" @select="addProduct"/>
                <div class="mt-1">
                  <div class="table-responsive mb-0">
                    <table class="table product__order__table">
                      <thead>
                      <tr>
                        <th>{{ $t('product') }}</th>
                        <th>{{ $t('note') }}</th>
                        <th class="text-center">{{ $t('sellPrice') }}</th>
                        <th class="text-center">{{ $t('quantity') }}</th>
                        <th class="text-right" style="min-width: 140px">{{ $t('intoMoney') }}</th>
                        <th v-if="!productDisabled" class="text-right" style="min-width: 75px"></th>
                      </tr>
                      </thead>
                      <tbody v-if="formModel.products && formModel.products.length">
                      <tr v-for="(item, index) in formModel.products" :key="index">
                        <td style="min-width: 300px" class="align-middle">
                          <div class="text__bigger" :class="[item.product ? 'text-primary' : '']">{{ item.name }}</div>
                        </td>
                        <td class="align-middle">
                          <b-form-input v-model="item.desc" :placeholder="$t('inputNote')"/>
                        </td>
                        <td class="text-center number__input__column align-middle">
                          <span>{{ item.price | numFormat }}&nbsp;&#8363;</span>
                        </td>
                        <td class="text-center number__input__column align-middle">
                          <span v-if="productDisabled">{{ item.quantity | numFormat }}</span>
                          <b-form-input v-else v-model="item.quantity" type="number" min="0"/>
                        </td>
                        <td class="text-right number__input__column text__bigger align-middle">
                          <span class="text-danger">{{ (Number(item.price) * (Number(item.quantity))) | numFormat }}&nbsp;&#8363;</span>
                        </td>
                        <td v-if="!productDisabled" class="text-right align-middle" style="min-width: 75px">
                          <button v-b-tooltip.hover.righttop="$t('delete')"
                                  class="btn btn-outline-danger btn-sm is-border-1" @click="removeProduct(index)">
                            <i class="fa fa-trash mr-0"></i>
                          </button>
                        </td>
                      </tr>
                      </tbody>
                      <tbody v-else>
                      <tr>
                        <td colspan="6">
                          <p class="text-center">
                            <img src="/img/empty-box.svg" alt="Empty box"/>
                          </p>
                          <p class="text-center text-gray-999"
                             :class="[formErrors && formErrors.length && formErrors.find(error => error.param === 'products') ? 'text-danger' : '']">
                            {{ $t('noAddedProduct') }}</p>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          <fieldset class="scheduler-border tile">
            <legend class="scheduler-border">{{ $t('orderInfo') }}</legend>
            <div class="row">
              <admin-user-select class="col-4" :model="formModel" attribute="user" :errors="formErrors"
                                 :label="$t('userInCharge')"
                                 :place-holder="$t('userInCharge')"></admin-user-select>
              <admin-user-select class="col-4" :model="formModel" attribute="sales" :errors="formErrors"
                                 :label="$t('sales')"
                                 :place-holder="$t('sales')"></admin-user-select>
            </div>
            <div class="row">
              <form-select :full-width="true" class="col" :label="$t('status')" :model="formModel" attribute="status"
                           :options="filteredStatusOptions"
                           :errors="formErrors"></form-select>
              <form-input class="col" :label="$t('source')" :model="formModel"
                          attribute="source"
                          :errors="formErrors"></form-input>
            </div>
            <div class="row">
              <div class="col">
                <form-textarea :label="$t('note')" :model="formModel" attribute="note"
                               :errors="formErrors"></form-textarea>
              </div>
              <div class="col">
                <form-textarea :label="$t('desc')" :model="formModel" attribute="desc"
                               :errors="formErrors"></form-textarea>
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-md-4">
          <fieldset class="scheduler-border tile">
            <legend class="scheduler-border">{{ $t('pay') }}</legend>
            <div class="row">
              <form-input class="col" :label="$t('customerShipFee')" :model="formModel" attribute="customerShipFee"
                          :errors="formErrors"></form-input>
              <form-input class="col" :label="$t('discountAmount')" :model="formModel" attribute="discountAmount"
                          :errors="formErrors"></form-input>
            </div>
            <div class="row">
              <form-input class="col" :label="$t('depositAmount')" :model="formModel" attribute="depositAmount"
                          :errors="formErrors"></form-input>
              <form-input class="col" :label="$t('transferAmount')" :model="formModel" attribute="transferAmount"
                          :errors="formErrors"></form-input>
            </div>
            <hr class="my-3">
            <div class="d-flex justify-content-between">
              <span>{{ $t('totalMoney') }}</span><span>{{ totalAmount | numFormat }}&nbsp;&#8363;</span>
            </div>
            <div class="d-flex justify-content-between mt-2">
              <span>{{ $t('paid') }}</span><span>{{ paidAmount | numFormat }}&nbsp;&#8363;</span>
            </div>
            <hr class="my-3">
            <div class="d-flex justify-content-between mt-1">
              <template v-if="lastAmount < 0">
                <span>{{ $t('returnAmount') }}</span><span
                  class="text-danger">{{ lastAmount * -1 | numFormat }}&nbsp;&#8363;</span>
              </template>
              <template v-else>
                <span>{{ $t('missingAmount') }}</span><span class="text-danger">{{ lastAmount | numFormat }}&nbsp;&#8363;</span>
              </template>
            </div>
          </fieldset>

          <fieldset class="scheduler-border tile">
            <legend class="scheduler-border">{{ $t('shipping') }}</legend>
            <client-select :label="$t('client')" :model="formModel" attribute="client"
                           :errors="formErrors"></client-select>
            <div class="row">
              <form-input class="col-6" :label="$t('shippingName')" :model="formModel" attribute="shippingName"
                          :errors="formErrors"></form-input>
              <form-input class="col-6" :label="$t('shippingPhone')" :model="formModel" attribute="shippingPhone"
                          :errors="formErrors"></form-input>
              <form-input class="col-12" :label="$t('shippingAddress')" :model="formModel"
                          attribute="shippingAddress"
                          :errors="formErrors"></form-input>
            </div>
            <div class="row">
              <form-input class="col-6" :label="$t('returnFee')" :model="formModel" attribute="returnFee"
                          :errors="formErrors"></form-input>
              <form-input class="col-6" :label="$t('overWeightShipFee')" :model="formModel"
                          attribute="overWeightShipFee"
                          :errors="formErrors"></form-input>
            </div>
            <div class="row">
              <form-input class="col-6" :label="$t('shipFee')" :model="formModel" attribute="shipFee"
                          :errors="formErrors"></form-input>
              <form-date-time class="col-6" :label="$t('deliveryTime')" :model="formModel" attribute="deliveryTime"
                              :errors="formErrors" format="DD/MM/YYYY HH:mm"
                              placeholder="DD/MM/YYYY HH:mm"></form-date-time>
            </div>
          </fieldset>
        </div>
      </div>

      <template v-slot:modal-footer>
        <button class="btn btn-secondary" @click="showForm = false">{{ $t('cancel') }}</button>
        <button class="btn btn-primary" @click="save"
                :disabled="!['owner', 'admin', 'tech', 'operationsManager', 'manager'].includes($store.state.user.role)">
          {{ $t('save') }}
        </button>
      </template>
    </b-modal>
  </main>
</template>

<script>
import List from '../../mixins/List'
import CRUD from '../../mixins/CRUD'
import AdminUserSelect from '@/components/AdminUserSelect.vue'
import ClientSelect from '@/components/ClientSelect.vue'
import ProductSearchBox from '@/components/ProductSearchBox.vue'
import TimeRangePicker from '@/components/TimeRangePicker.vue'

export default {
  components: {TimeRangePicker, ProductSearchBox, ClientSelect, AdminUserSelect},
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/admin-order',
      autoLoad: true,
      defaultFilterFormModel: {
        keyword: null,
        status: null
      },
      defaultFormModel: {
        customerShipFee: 0,
        returnFee: 0,
        overWeightShipFee: 0,
        discountAmount: 0,
        depositAmount: 0,
        transferAmount: 0,
        shippingEnabled: false,
        status: 'new',
        products: [],
        user: null,
        sales: null,
        account: null,
        source: null,
        printCount: 0,
        note: null,
        desc: null,
        client: null,
        shippingName: null,
        shippingPhone: null,
        shippingAddress: null,
        shipFee: 0
      },
      totalAmount: 0,
      totalProductAmount: 0,
      totalDiscount: 0,
      orderStatus: [
        {value: null, text: this.$t('status')},
        {
          value: 'new', text: this.$t('waitForPay'),
          nextStatuses: ['restocking', 'confirmed', 'packing', 'pickup', 'shipped', 'shipping', 'success', 'cancel']
        },
        {
          value: 'restocking', text: this.$t('restocking'),
          nextStatuses: ['confirmed', 'packing', 'pickup', 'shipped', 'shipping', 'success', 'cancel']
        },
        {
          value: 'confirmed', text: this.$t('paid'),
          nextStatuses: ['restocking', 'packing', 'pickup', 'shipped', 'shipping', 'success', 'cancel']
        },
        {
          value: 'packing', text: this.$t('packing'),
          nextStatuses: ['confirmed', 'restocking', 'pickup', 'shipped', 'shipping', 'success', 'cancel']
        },
        {
          value: 'pickup', text: this.$t('pickup'),
          nextStatuses: ['confirmed', 'shipped', 'shipping', 'success', 'cancel']
        },
        {
          value: 'shipped', text: this.$t('shippedStatus'),
          nextStatuses: ['return', 'returned', 'success', 'cancel']
        },
        {
          value: 'shipping', text: this.$t('shippingStatus'),
          nextStatuses: ['return', 'returned', 'success', 'cancel']
        },
        {
          value: 'success', text: this.$t('successStatus'),
          nextStatuses: ['return', 'returned', 'shipping', 'cancel']
        },
        {
          value: 'return', text: this.$t('refund'),
          nextStatuses: ['shipping', 'returned', 'success', 'cancel']
        },
        {
          value: 'returned', text: this.$t('refunded'),
          nextStatuses: ['cancel']
        },
        {
          value: 'cancel', text: this.$t('canceled'),
          nextStatuses: []
        }
      ]
    }
  },
  methods: {
    updateTotalAmount() {
      this.totalAmount = Number(this.totalProductAmount) + Number(this.formModel.customerShipFee) + Number(this.formModel.returnFee) + Number(this.formModel.overWeightShipFee) - this.lastDiscount
    },
    addProduct(item) {
      let existedProduct = this.formModel.products.find(p => p.product === item._id)
      if (existedProduct) {
        existedProduct.quantity++
      } else {
        this.formModel.products.push({
          product: item._id,
          sku: item.sku,
          name: item.name,
          price: item.sellPrice ? item.sellPrice : 0,
          quantity: 1,
          desc: ''
        })
      }
    },
    removeProduct(index) {
      this.formModel.products.splice(index, 1)
    },
    getStatus(value) {
      if (['new', 'confirmed'].includes(value)) {
        switch (value) {
          case 'new':
            return this.$t('waitForPay')
          case 'confirmed':
            return this.$t('paid')
        }
      }
      return this.orderStatus.find(status => status.value === value).text
    },
    save: function (evt, fn, customUrl) {
      if (evt) {
        evt.preventDefault()
      }
      let loader = this.$loading.show()
      let method = 'post'
      let url = this.service
      if (this.formModel.id) {
        method = 'put'
        url += '/' + this.formModel.id
      }
      if (customUrl) {
        url = customUrl
      }
      this.formModel.totalAmount = this.totalAmount
      this.$service({url: url, method: method, data: this.formModel}).then(response => {
        this.showForm = false
        if (this.load) {
          this.load()
        }
        if (this.reloadBus) {
          this.$bus.$emit(this.reloadBus)
        }
        if (fn) {
          fn()
        }
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t(this.formModel.id ? 'updated' : 'created'),
            icon: 'success'
          })
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t(this.formModel.id ? 'updateFailed' : 'createFailed'),
            icon: 'error'
          })
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          })
          this.showForm = false
        } else {
          this.formErrors = error.response.data
        }
      }).finally(() => {
        loader.hide()
      })
    },
    create: function () {
      this.formModel = {}
      this.formModel = Object.assign({}, this.formModel, this.defaultFormModel)
      this.formModel.products = []
      this.formTitle = this.$t('create')
      this.formErrors = []
      this.showForm = true
    },
    orderCare(id) {
      let loader = this.$loading.show()
      this.$service.put(this.service + '/care/' + id).then(response => {
        if (response.data) {
          if (this.load) {
            this.load()
          }
          if (this.reloadBus) {
            this.$bus.$emit(this.reloadBus)
          }
          this.$swal({
            title: this.$t('success'),
            text: this.$t('receiveOrderSuccessfully'),
            icon: 'success',
            toast: true,
            position: 'top-right',
            timer: 5000
          })
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t('receiveOrderFailed'),
            icon: 'error'
          })
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          })
        }
      }).finally(() => {
        loader.hide()
      })
    }
  },
  computed: {
    productDisabled() {
      return this.formModel._id && !['new', 'confirmed', 'restocking', 'packing', 'pickup'].includes(this.formModel.status)
    },
    lastDiscount() {
      return this.totalDiscount + Number(this.formModel.discountAmount)
    },
    paidAmount() {
      return Number(this.formModel.depositAmount) + Number(this.formModel.transferAmount)
    },
    lastAmount() {
      return this.totalAmount - this.paidAmount
    },
    filteredStatusOptions() {
      let statusValue = 'new'
      if (this.formModel._id) {
        statusValue = this.formModel.status
      }
      let status = this.orderStatus.find(status => status.value === statusValue)
      let options = []
      if (status) {
        options = this.orderStatus.filter(({value}) => value === statusValue || status.nextStatuses.includes(value))
        options.sort((a, b) => status.nextStatuses.indexOf(a.value) - status.nextStatuses.indexOf(b.value))
      }
      return options
    }
  },
  i18n: {
    messages: {
      en: {
        code: 'Code',
        listPrice: 'List price',
        sellPrice: 'Sell price',
        category: 'Category',
        image: 'Image',
        createdBy: 'Created by',
        updatedBy: 'Updated by',
        noAddedProduct: 'You haven\'t added any products yet',
        product: 'Product',
        quantity: 'Quantity',
        intoMoney: 'Into money',
        customer: 'Customer',
        shippingEnabled: 'Recipient information is different from customer information',
        shipping: 'Shipping',
        shipFee: 'Ship fee',
        deliveryTime: 'Delivery time',
        receiving: 'Receiving',
        shippingName: 'Name',
        shippingPhone: 'Phone',
        shippingAddress: 'Address',
        orderInfo: 'Order information',
        userInCharge: 'User in charge',
        account: 'Account',
        source: 'Source',
        printCount: 'Print count',
        note: 'Internal notes',
        desc: 'Notes to print',
        pay: 'Pay',
        customerShipFee: 'Customer\'s shipping fee',
        returnFee: 'Return fee',
        overWeightShipFee: 'Overweight fee',
        discountAmount: 'Discount on order',
        depositAmount: 'Deposits',
        transferAmount: 'Money transfer',
        totalMoney: 'Total amount',
        inputNote: 'Enter notes',
        paid: 'Paid',
        missingAmount: 'Missing amount',
        returnAmount: 'Return amount',
        newStatus: 'New',
        restocking: 'Restocking',
        confirmed: 'Confirmed',
        packing: 'Packing',
        pickup: 'Waiting for pickup',
        shippedStatus: 'Shipped',
        shippingStatus: 'Shipping',
        successStatus: 'Received',
        refund: 'Refund',
        refunded: 'Refunded',
        canceled: 'Canceled',
        productCount: 'Number of products',
        buyUser: 'Purchased by staff',
        confirmTime: 'Confirm time',
        finishTime: 'Finish time',
        cancelTime: 'Cancel time',
        selectSource: 'Select source',
        orderCare: 'Receive order',
        receiveOrderFailed: 'Order received failed',
        receiveOrderSuccessfully: 'Order received successfully',
        waitForPay: 'Wait for pay',
        payCode: 'Payment code',
        payInfo: 'Payment information'
      },
      vi: {
        code: 'Mã',
        listPrice: 'Giá nhập',
        sellPrice: 'Giá bán',
        category: 'Danh mục',
        image: 'Ảnh',
        createdBy: 'Tạo bởi',
        updatedBy: 'Cập nhật bởi',
        noAddedProduct: 'Bạn chưa thêm sản phẩm nào',
        product: 'Sản phẩm',
        quantity: 'Số lượng',
        intoMoney: 'Thành tiền',
        customer: 'Khách hàng',
        shippingEnabled: 'Thông tin người nhận khác với thông tin khách hàng',
        shipping: 'Vận chuyển',
        shipFee: 'Phí vận chuyển',
        deliveryTime: 'Thời gian vận chuyển',
        receiving: 'Nhận hàng',
        shippingName: 'Tên người nhận',
        shippingPhone: 'Số điện thoại',
        shippingAddress: 'Địa chỉ',
        orderInfo: 'Thông tin đơn hàng',
        userInCharge: 'Nhân viên phụ trách',
        account: 'Chăm sóc',
        source: 'Nguồn',
        printCount: 'Số lượng in',
        note: 'Ghi chú nội bộ',
        desc: 'Ghi chú để in',
        pay: 'Thanh toán',
        customerShipFee: 'Phí vận chuyển của KH',
        returnFee: 'Phí chuyển hoàn',
        overWeightShipFee: 'Phí vượt cân',
        discountAmount: 'Giảm giá trên đơn hàng',
        depositAmount: 'Tiền đặt cọc',
        transferAmount: 'Tiền chuyển khoản',
        totalMoney: 'Tổng số tiền',
        inputNote: 'Nhập ghi chú',
        paid: 'Đã thanh toán',
        missingAmount: 'Số tiền còn thiếu',
        returnAmount: 'Số tiền trả lại',
        newStatus: 'Mới',
        restocking: 'Chờ hàng',
        confirmed: 'Đã xác nhận',
        packing: 'Đang đóng gói',
        pickup: 'Chờ lấy hàng',
        shippedStatus: 'Đã gửi hàng',
        shippingStatus: 'Đang giao hàng',
        successStatus: 'Đã nhận',
        refund: 'Hoàn hàng',
        refunded: 'Đã hoàn',
        canceled: 'Đã huỷ',
        productCount: 'Số lượng sản phẩm',
        buyUser: 'Mua bởi nhân viên',
        confirmTime: 'Xác nhận lúc',
        finishTime: 'Hoàn thành lúc',
        cancelTime: 'Huỷ lúc',
        selectSource: 'Chọn nguồn',
        orderCare: 'Nhận đơn',
        receiveOrderFailed: 'Nhận đơn thất bại',
        receiveOrderSuccessfully: 'Nhận đơn thành công',
        waitForPay: 'Chờ thanh toán',
        payCode: 'Mã thanh toán',
        payInfo: 'Thông tin thanh toán'
      }
    }
  },
  watch: {
    'totalProductAmount': function () {
      this.updateTotalAmount()
    },
    'formModel.discountAmount': function () {
      this.updateTotalAmount()
    },
    'formModel.customerShipFee': function () {
      this.updateTotalAmount()
    },
    'formModel.returnFee': function () {
      this.updateTotalAmount()
    },
    'formModel.overWeightShipFee': function () {
      this.updateTotalAmount()
    },
    'formModel.products': {
      handler: function (val) {
        if (!val) return
        let totalProductAmount = 0
        val.forEach((product) => {
          totalProductAmount += Number(product.quantity) * Number(product.price)
        })
        this.totalProductAmount = totalProductAmount
      },
      deep: true
    }
  }
}
</script>

<style>
.modal-fullscreen .modal-dialog {
  max-width: 98%;
}

.product__order__table thead th {
  font-size: 1em;
}

.product__order__table tbody input {
  font-size: 1.1em;
  border-width: 1px;
}

.product__order__table .number__input__column {
  width: 125px !important;
}

.product__order__table .number__input__column input {
  text-align: right;
}

.text__bigger {
  font-size: 1.1em;
}

.table.product__order__table th,
.table.product__order__table td {
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
}

.table.product__order__table th {
  background-color: #f1f5fb;
  border-bottom-width: 2px;
}

.table.product__order__table th:first-child,
.table.product__order__table td:first-child {
  border-left: 1px solid #dee2e6;
}

.table.product__order__table th:last-child,
.table.product__order__table td:last-child {
  border-right: 1px solid #dee2e6;
}

.custom-modal .modal-content {
  background-color: #f5f5f5;
}

/* Remove input number arrow */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}
</style>